var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.showBanner
    ? _c(
        "div",
        {
          staticClass: "container slide-in-bottom",
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex",
            },
            [
              _c("div", [
                _c("img", {
                  staticClass: "app-rounded",
                  attrs: {
                    src: "/FirstCallOnline/images/OReillyProAppIcon.webp",
                    height: "60",
                    alt: _vm.fcoM("common.oreillyPro", "O'Reilly Pro"),
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "ml-3 mt-1",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "mb-0",
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.fcoM("common.oreillyPro", "O'Reilly Pro"))
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "small text-muted mt-0",
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.fcoM(
                            "common.oreillyProTagline",
                            "Dedicated to the professional"
                          )
                        )
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "ml-auto",
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "javaScript:void(0)",
                      },
                      on: {
                        click: _vm.handleCloseBanner,
                      },
                    },
                    [
                      _c("Icon", {
                        staticClass: "black",
                        attrs: {
                          name: "times",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex mt-3",
            },
            [
              _vm.isIphoneNotSafari
                ? _c(
                    "a",
                    {
                      staticClass: "ml-auto",
                      attrs: {
                        href: "itms-apps://itunes.apple.com/app/id6467030803",
                      },
                    },
                    [
                      _vm.locale === _vm.localeConstant.ES
                        ? _c("img", {
                            attrs: {
                              src: "/FirstCallOnline/images/Download_on_the_App_Store_Badge_ESMX_RGB_blk_100217.svg",
                              alt: _vm.fcoM(
                                "mobileApp.appleStoreAlt",
                                "Download on the App Store"
                              ),
                              height: "40px",
                            },
                          })
                        : _c("img", {
                            attrs: {
                              src: "/FirstCallOnline/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg",
                              alt: _vm.fcoM(
                                "mobileApp.appleStoreAlt",
                                "Download on the App Store"
                              ),
                              height: "40px",
                            },
                          }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isAndroid
                ? _c(
                    "a",
                    {
                      staticClass: "ml-auto",
                      attrs: {
                        href: "https://play.google.com/store/apps/details?id=com.oreillyauto.professional",
                      },
                    },
                    [
                      _vm.locale === _vm.localeConstant.ES
                        ? _c("img", {
                            attrs: {
                              src: "/FirstCallOnline/images/GetItOnGooglePlay_Badge_Web_color_Spanish.png",
                              alt: _vm.fcoM(
                                "mobileApp.androidStoreAlt",
                                "Get it on Google Play"
                              ),
                              height: "40px",
                            },
                          })
                        : _c("img", {
                            attrs: {
                              src: "/FirstCallOnline/images/GetItOnGooglePlay_Badge_Web_color_English.png",
                              alt: _vm.fcoM(
                                "mobileApp.androidStoreAlt",
                                "Get it on Google Play"
                              ),
                              height: "40px",
                            },
                          }),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }